export default __webpack_public_path__ + "b99ba76a5a57684a920882cdd92f1c0a.png";